<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super">Logo</div>
              <div class="icon-clickable-right" @click="openModal('assignLogo')">
                <feather type="plus"></feather>
              </div>
            </div>
            <div class="logo_container">
              <transition
                :name="animations.standard.name"
                :enter-active-class="animations.standard.enter"
                :leave-active-class="animations.standard.leave"
              >
                <div class="logo_thumbnail" style="text-align:center;">
                  <img class="rounded-circle" v-if="logo_source" :src="logo_source.thumbnails[3].url" />
                </div>
              </transition>
              <!-- Modal Assign Logo -->
              <b-modal size="sm" id="assignLogo" ok-only @ok="newLogo">
                <div class="logo_dropzone">
                  <vue-dropzone
                    ref="logo_dropzone"
                    :options="logo_dropzone_options"
                    id="logo_dropzone"
                    v-on:vdropzone-success="processAsset"
                  ></vue-dropzone>
                </div>
                <template slot="modal-header">
                  Neues Logo hochladen
                </template>
              </b-modal>
              <!-- Assign Logo End -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super">Daten</div>
            </div>
            <div class="form-container">
              <label>Firmenname*</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input
                  class="form-control"
                  name="name"
                  v-model="name"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('name') }"
                ></b-form-input>
                <feather type="check" v-if="!hasError('name') && !updating.name" name="name" class="checkmark"></feather>
                <Loader size="20" v-if="updating.name" />
              </b-input-group>
              <label>Telefon</label>
              <b-input-group class="form-input-group" prepend="123">
                <b-form-input
                  class="form-control"
                  name="telefon"
                  v-model="telefon"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('telefon') }"
                ></b-form-input>
                <feather type="check" v-if="!hasError('telefon') && !updating.telefon" telefon="telefon" class="checkmark"></feather>
                <feather type="x" v-if="hasError('telefon') && !updating.telefon" telefon="telefon" class="failmark"></feather>
                <Loader size="20" v-if="updating.telefon" />
              </b-input-group>
              <label>Email</label>
              <b-input-group class="form-input-group" prepend="@">
                <b-form-input
                  class="form-control"
                  name="email"
                  v-model="email"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('email') }"
                ></b-form-input>
                <feather type="check" v-if="!hasError('email') && !updating.email" email="email" class="checkmark"></feather>
                <feather type="x" v-if="hasError('email') && !updating.email" email="email" class="failmark"></feather>
                <Loader size="20" v-if="updating.email" />
              </b-input-group>
              <label>Ansprechpartner</label>
              <b-input-group class="form-input-group" prepend="Abc">
                <b-form-input
                  class="form-control"
                  name="ansprechpartner"
                  v-model="ansprechpartner"
                  @blur="validate"
                  v-bind:class="{ form_error: hasError('ansprechpartner') }"
                ></b-form-input>
                <feather type="check" v-if="!hasError('ansprechpartner') && !updating.ansprechpartner" class="checkmark"></feather>
                <feather type="x" v-if="hasError('ansprechpartner') && !updating.ansprechpartner" class="failmark"></feather>
                <Loader size="20" v-if="updating.ansprechpartner" />
              </b-input-group>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super">Branchen</div>
              <div class="icon-clickable-right" @click="openModal('assignBranchen')">
                <feather type="plus"></feather>
              </div>
            </div>
            <transition :name="animations.fadeIn.name" :enter-active-class="animations.fadeIn.enter" :leave-active-class="animations.fadeIn.leave">
              <b-table thead-class="hidden" show-empty stacked="md" :items="selected.branchen" :fields="listfields.branchen">
                <template slot="empty">
                  Keine Branchen zugewiesen.
                </template>
              </b-table>
            </transition>
            <div class="flex-row-end" style="margin-top:30px;">
              <b-button class="btn btn-primary" @click="openModal('assignBranchen')">Branche zuweisen </b-button>
            </div>
          </div>
        </div>
        <!-- Modal Branchen -->
        <b-modal size="md" id="assignBranchen" @ok="saveRelation('branchen')" ok-only @hide="resetBranchenModal">
          <b-tabs v-model="tabs.branchen">
            <b-tab title="Zuweisen">
              <div class="row" style="margin-top:10px;">
                <div class="col-12">
                  <b-input-group class="datatable-btn search_input">
                    <b-form-input v-model="filter.branchen" placeholder="Suchen"></b-form-input>
                  </b-input-group>
                </div>
              </div>
              <div class="table-responsive datatable-vue">
                <b-table
                  show-empty
                  stacked="md"
                  :items="items.branchen"
                  :fields="tablefields.branchen"
                  :filter="filter.branchen"
                  :current-page="currentPage.branchen"
                  :per-page="perPage.branchen"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(auswahl)="selection">
                    <input
                      type="checkbox"
                      name="branchen"
                      :checked="isAssigned('branchen', selection)"
                      :class="{ inactive: updating.dienstleister_branchen }"
                      @change="toggleSelection('branchen', selection)"
                    />
                  </template>
                  <template slot="empty"><div class="text-center">Keine Branchen erstellt.</div> </template>
                  <template v-slot:cell(delete)="row">
                    <feather
                      class="infra-blue pointer"
                      type="trash"
                      :id="'delete_branche_' + row.item.id"
                      @click="deleteBranche(row.item.id)"
                    ></feather>
                    <b-tooltip :target="'delete_branche_' + row.item.id" triggers="hover" placement="left"></b-tooltip>
                  </template>
                </b-table>
              </div>
              <b-col md="6" class="my-1">
                <b-pagination
                  v-if="totalRows.branchen > perPage.branchen"
                  v-model="currentPage.branchen"
                  :total-rows="totalRows.branchen"
                  :per-page="perPage.branchen"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-tab>
            <b-tab title="Neu" v-model="tabs.branchen">
              <label style="margin-top:10px;">Bezeichnung</label>&nbsp;
              <div class="red inline-block" v-if="hasError('branche_name')">- mindestens {{ validation.branchen.name.minlength }} Zeichen.</div>
              <b-input-group prepend="Abc" class="form-input-group">
                <b-form-input v-model="modal.branche_neu.name" v-bind:class="{ form_error: hasError('branche_name') }"></b-form-input>
              </b-input-group>
              <b-button class="btn btn-primary" @click="validateBranche">Branche hinzufügen</b-button>
            </b-tab>
          </b-tabs>

          <template slot="modal-title">
            <h4>Branchen zuordnen</h4>
          </template>
          <template slot="modal-ok" name="branchen">
            Schließen
          </template>
        </b-modal>
        <!-- /Modal Branchen -->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="headline_under">
              <div class="v-super">Zugewiesene Einheiten</div>
              <div class="icon-clickable-right">
                <feather type="plus" @click="openModal('assignDienstleisterElements')"></feather>
              </div>
            </div>
            <b-row>
              <b-col md="12" class="list_mode iam-table-ux" style="margin-top:20px;">
                <b-input-group class="datatable-btn">
                  <div>
                    <b-form-input style="border:1px solid lightgrey" v-model="filter.elemente" placeholder="Suchen"></b-form-input>
                  </div>
                </b-input-group>
              </b-col>
            </b-row>
            <div class="table-responsive datatable-vue">
              <b-table
                show-empty
                stacked="md"
                :items="items.elemente"
                :totalRows="totalRows.elemente"
                :fields="listfields.elemente"
                :filter="filter.elemente"
                :current-page="currentPage.elemente"
                :per-page="perPage.elemente"
                @filtered="onFilteredElements"
              >
                <template slot="empty">
                  <div class="text-center">Keine Elemente zugewiesen.</div>
                </template>
                <template v-slot:cell(qm)="ref">
                  <span v-if="ref.item.qm">{{ ref.item.qm }} m<sup>2</sup></span>
                </template>
                <template v-slot:cell(aktionen)="row">
                  <div>
                    <feather
                      style="margin-right:5px;"
                      :id="'edit-wohnung-' + row.item.wohnung_id"
                      type="edit-2"
                      class="infra-blue pointer"
                      @click="
                        $router.push(
                          '/admin/dashboard/bauprojekte/' + row.item.bauprojekt_id + '/haus/' + row.item.haus_id + '/wohnung/' + row.item.wohnung_id
                        )
                      "
                    ></feather>
                    <b-tooltip :target="'edit-wohnung-' + row.item.wohnung_id" triggers="hover" placement="left">Wohnung bearbeiten</b-tooltip>
                    <feather
                      class="infra-blue pointer"
                      type="map"
                      :id="'tobp-wohnung' + row.item.wohnung_id"
                      @click="$router.push('/admin/dashboard/bauprojekte/' + row.item.bauprojekt_id)"
                    ></feather>
                    <b-tooltip :target="'tobp-wohnung' + row.item.wohnung_id" triggers="hover" placement="left">zum Bauprojekt</b-tooltip>
                  </div>
                </template>
              </b-table>
            </div>
            <b-col md="6" class="my-1">
              <b-pagination
                v-if="totalRows.elemente > perPage.elemente"
                v-model="currentPage.elemente"
                :total-rows="totalRows.elemente"
                :per-page="perPage.elemente"
                class="my-0"
              ></b-pagination>
            </b-col>
            <div class="flex-row-end" style="margin-top:30px;">
              <b-button class="btn btn-primary" @click="openModal('assignDienstleisterElements')">Einheiten zuweisen</b-button>
            </div>
          </div>
          <!-- Modal Assign Elements -->
          <b-modal size="lg" id="assignDienstleisterElements">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="assign_items_container">
                    <div class="assign_bauprojekte_container" v-if="modalStep == 0">
                      <div class="table-responsive datatable-vue" v-if="items.bauprojekte.length">
                        <b-table
                          show-empty
                          stacked="md"
                          :items="items.bauprojekte"
                          :fields="tablefields.bauprojekte"
                          :filter="filter.bauprojekte"
                          :current-page="currentPage.bauprojekte"
                          :per-page="perPage.bauprojekte"
                          @filtered="onFiltered"
                        >
                          <template v-slot:cell(chosen)="chosen">
                            <feather type="x" v-if="!isAssigned('bauprojekte', chosen)"></feather>
                            <feather type="check" v-else class="green"></feather>
                          </template>
                          <template v-slot:cell(next)="next">
                            <div class="ico-container">
                              <div>
                                <button
                                  style="margin-right:5px;"
                                  @click="toggleSelection('bauprojekte', next)"
                                  class="btn btn-xs btn-secondary"
                                  v-bind:class="{ 'btn-warning': isAssigned('bauprojekte', next), inactive: updating.modal }"
                                >
                                  {{ isAssigned("bauprojekte", next) ? "Abwählen" : "Zuweisen" }}
                                </button>
                              </div>
                              <div v-if="!isAssigned('bauprojekte', next)" class="next_arrow_container">
                                <feather
                                  :id="'goto_hauser_' + next.item.id"
                                  class="pointer infra-blue"
                                  type="arrow-right"
                                  @click="modalSelect('bauprojekt', next)"
                                ></feather>
                                <b-tooltip trigger="hover" placment="top" :target="'goto_hauser_' + next.item.id" placement="left"
                                  >Zu den Häusern</b-tooltip
                                >
                              </div>
                            </div>
                          </template>
                        </b-table>
                      </div>
                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-if="totalRows.bauprojekte > perPage.bauprojekte"
                          v-model="currentPage.bauprojekte"
                          :total-rows="totalRows.bauprojekte"
                          :per-page="perPage.bauprojekte"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                    </div>
                    <div class="assign_hauser_container" v-if="modalStep == 1">
                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          stacked="md"
                          :items="modal.bauprojekt.extended.hauser"
                          :fields="tablefields.hauser"
                          :filter="filter.hauser"
                          :current-page="currentPage.hauser"
                          :per-page="perPage.hauser"
                          @filtered="onFiltered"
                        >
                          <template v-slot:cell(chosen)="chosen">
                            <feather type="check" v-if="isAssigned('hauser', chosen)" class="green"></feather>
                            <feather class="infra-grey" type="check" v-else-if="isAssignedImplicit('haus_id', chosen)"></feather>
                            <feather type="x" v-else></feather>
                          </template>
                          <template v-slot:cell(next)="next">
                            <div class="ico-container">
                              <div>
                                <button
                                  style="margin-right:5px;"
                                  @click="toggleSelection('hauser', next)"
                                  class="btn btn-xs btn-secondary"
                                  v-bind:class="{ 'btn-warning': isAssigned('hauser', next), inactive: updating.modal }"
                                >
                                  {{ isAssigned("hauser", next) ? "Abwählen" : "Zuweisen" }}
                                </button>
                              </div>
                              <div v-if="!isAssigned('hauser', next)" class="next_arrow_container">
                                <feather
                                  :id="'goto_wohnung_' + next.item.id"
                                  class="pointer infra-blue"
                                  type="arrow-right"
                                  title="zu den Wohnungen"
                                  @click="modalSelect('haus', next)"
                                ></feather>
                                <b-tooltip :target="'goto_wohnung_' + next.item.id" triggers="hover" placement="left">zu den Wohnungen</b-tooltip>
                              </div>
                            </div>
                          </template>
                          <template v-slot:cell(tgstell_preis)="haus">
                            <span v-if="haus.item.tgstell_preis">{{ haus.item.tgstell_preis }} m<sup>2</sup></span>
                          </template>
                          <template v-slot:cell(stell_preis)="haus">
                            <span v-if="haus.item.stell_preis">{{ haus.item.stell_preis }} m<sup>2</sup></span>
                          </template>
                        </b-table>
                      </div>
                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-if="totalRows.hauser > perPage.hauser"
                          v-model="currentPage.hauser"
                          :total-rows="totalRows.hauser"
                          :per-page="perPage.hauser"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                    </div>
                    <div class="assign_wohnungen_container" v-if="modalStep == 2">
                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          stacked="md"
                          :items="modal.haus.extended.wohnungen"
                          :fields="tablefields.wohnungen"
                          :filter="filter.wohnungen"
                          :current-page="currentPage.wohnungen"
                          :per-page="perPage.wohnungen"
                          @filtered="onFiltered"
                        >
                          <template v-slot:cell(aktionen)="aktionen">
                            <div class="ico-container">
                              <button
                                :disabled="updating.modal"
                                style="margin-right:5px;"
                                @click="toggleSelection('wohnungen', aktionen)"
                                class="btn btn-xs btn-secondary"
                                v-bind:class="{ 'btn-warning': isAssigned('wohnungen', aktionen), inactive: updating.modal }"
                              >
                                {{ isAssigned("wohnungen", aktionen) ? "Abwählen" : "Zuweisen" }}
                              </button>
                            </div>
                          </template>
                          <template v-slot:cell(chosen)="chosen">
                            <feather type="check" v-if="isAssigned('wohnungen', chosen)" class="green"></feather>
                            <feather class="infra-grey" type="check" v-else-if="isAssignedImplicit('wohnung_id', chosen)"></feather>
                            <feather type="x" v-else></feather>
                          </template>

                          <template v-slot:cell(wohnflaeche)="wohnung">
                            <span v-if="wohnung.item.wohnflaeche">{{ wohnung.item.wohnflaeche }} m<sup>2</sup></span>
                          </template>
                          <template v-slot:cell(kaufpreis)="wohnung">
                            <span v-if="wohnung.item.kaufpreis">{{ displayCurrency(wohnung.item.kaufpreis) }}</span>
                          </template>
                        </b-table>
                      </div>
                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-if="totalRows.wohnungen > perPage.wohnungen"
                          v-model="currentPage.wohnungen"
                          :total-rows="totalRows.wohnungen"
                          :per-page="perPage.wohnungen"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template v-slot:modal-header>
              <h4 v-if="modalStep == 0">Bauprojekt zuweisen</h4>
              <h4 v-if="modalStep == 1">{{ modal.bauprojekt.name }} | Häuser</h4>
              <h4 v-if="modalStep == 2">{{ modal.bauprojekt.name }} | {{ modal.haus.name }} | Wohnungen</h4>
            </template>
            <template v-slot:modal-footer>
              <Loader v-if="updating.modal" size="35" style="position:relative!important" />
              <transition
                :name="animations.standard.name"
                :enter-active-class="animations.standard.enter"
                :leave-active-class="animations.standard.leave"
              >
                <button class="btn btn-secondary" v-if="modalStep > 0" @click="goBack">Zurück</button>
              </transition>
              <button class="btn btn-primary" @click="closeModal('assignDienstleisterElements')">Schließen</button>
            </template>
          </b-modal>
          <!-- Ende Modal Assign Elements -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";
import vue2Dropzone from "vue2-dropzone";

export default {
  name: "AdminEditDienstleister",
  components: {
    Loader: Loader,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      id: false,
      name: false,
      telefon: false,
      email: false,
      ansprechpartner: false,
      logo: false,
      logo_source: false,
      validation_errors: [],
      dzThumbSize: 200,
      modalStep: 0,
      updating: {
        name: false,
        email: false,
        telefon: false,
        modal: false,
        branchen: false,
        dienstleister: false,
        bauprojekte: false,
        hauser: false,
        ansprechpartner: false,
      },
      tablefields: {
        branchen: [
          { key: "auswahl", label: "Auswahl", sortable: false },
          { key: "name", label: "Branche", sortable: true },
          { key: "delete", label: "Aktionen", sortable: false },
        ],
        bauprojekte: [
          { key: "chosen", label: "Zuweisung", sortable: true },
          { key: "name", label: "Name", sortable: true },
          { key: "next", label: "Aktionen", sortable: false },
        ],
        hauser: [
          { key: "chosen", label: "Zuweisung", sortable: false },
          { key: "name", label: "Haus", sortable: true },
          { key: "extended.wohnungen.length", label: "Wohnungen", sortable: true },
          { key: "next", label: "Aktionen", sortable: false },
        ],
        wohnungen: [
          { key: "chosen", label: "Zuweisung", sortable: false },
          { key: "name", label: "Name", sortable: true },
          { key: "etage", label: "Etage", sortable: true },
          { key: "wohnflaeche", label: "Wohnfläche", sortable: true },
          { key: "aktionen", label: "Aktionen", sortable: true },
        ],
      },
      listfields: {
        branchen: [{ key: "name", label: "Name", sortable: true }],
        elemente: [
          { key: "wohnung", label: "Name", sortable: true },
          { key: "haus", label: "Haus", sortable: true },
          { key: "bauprojekt", label: "Bauprojekt", sortable: true },
          { key: "qm", label: "Wohnflaeche", sortable: true },
          { key: "aktionen", label: "Aktionen", sortable: false },
        ],
      },
      filter: {
        branchen: null,
        elemente: null,
        hauser: null,
        wohnungen: null,
      },
      totalRows: {
        branchen: 1,
        elemente: 1,
        wohnungen: 1,
        hauser: 1,
      },
      currentPage: {
        branchen: 1,
        elemente: 1,
        hauser: 1,
        wohnungen: 1
      },
      perPage: {
        branchen: 10,
        elemente: 10,
        wohnungen: 10,
        hauser: 10,
      },
      pageOptions: {
        branchen: [10, 50, 100],
        elemente: [10, 50, 100],
      },
      items: {
        branchen: [],
        bauprojekte: [],
        hauser: [],
        wohnungen: [],
        elemente: [],
      },
      selected: {
        branchen: [],
        bauprojekte: [],
        hauser: [],
        wohnungen: [],
      },
      current: {
        wohnungen: false,
        haus: false,
        bauprojekt: false,
        branchen: [],
      },
      modal: {
        bauprojekt: false,
        haus: false,
        wohnung: false,
        branche_neu: {
          name: "",
        },
      },
      tabs: {
        branchen: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      ready: "app/readyState",
      dienstleister: "app/dienstleister",
      toast: "app/toasts",
      api: "auth/apiSettings",
      branchen: "app/branchen",
      bauprojekte: "app/bauprojekte",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      animations: "app/animations",
      validation: "app/validation",
    }),
  },
  created: async function() {
    //get data for current DL
    this.setDlData();
    this.setTableData();

    //kundenbild dropzone
    this.logo_dropzone_options = {
      url: this.api.customUploads,
      thumbnailMethod: "contain",
      thumbnailWidth: this.dzThumbSize,
      maxFiles: 1,
      init: function() {
        this.on("maxfilesexceeded", function(file) {
          this.removeAllFiles();
          this.addFile(file);
        });
      },
      dictDefaultMessage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

      headers: {
        Authorization: "bearer " + JSON.parse(localStorage.getItem("directus-sdk-js")).token,
        "Cache-Control": null,
        "X-Requested-With": null,
      },
    };

    //assign existing logo
    if (this.logo) {
      this.newLogo();
    }    
  },
  methods: {
    resetBranchenModal() {
      this.modal.branche_neu = {
        name: "",
      };
    },
    async validateBranche() {
      this.validation_errors = [];
      const field = this.modal.branche_neu.name;
      const validationPayload = {
        context: "branchen",
        field: "name",
        value: field,
      };
      const validation = await this.$store.dispatch("app/validateField", validationPayload);

      if (!validation) this.validation_errors.push("branche_name");
      if (validation) {
        try {
          await this.$store.dispatch("app/addBranche", { name: field, status: "published" });
          await this.$store.dispatch("app/apiGetBranchen");
          this.setTableData();
          this.tabs.branchen = 0;
          this.resetBranchenModal();
        } catch (error) {
          console.log(error);
          this.$toasted.show(error, this.toasts.failure);
        }
      }
    },
    async deleteBranche(brId) {
      try {
        await this.$store.dispatch("app/deleteBranche", brId);
        await this.$store.dispatch("app/apiGetBranchen");
        this.setTableData();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    provisionElements() {
      let assignedElements = [];

      //assign wohnungen in bauprojekt
      this.selected.bauprojekte.forEach((bp) => {
        if (!bp.extended.hauser.length) return;
        bp.extended.hauser.forEach((haus) => {
          if (!haus.extended.wohnungen.length) return;
          haus.extended.wohnungen.forEach((wohnung) => {
            let result = {
              bauprojekt: bp.name,
              bauprojekt_id: bp.id,
              haus: haus.name,
              haus_id: haus.id,
              wohnung: wohnung.name,
              qm: wohnung.wohnflaeche,
              wohnung_id: wohnung.id,
            };
            if (assignedElements.indexOf(result) > -1) return;
            assignedElements.push(result);
          });
        });
      });

      //assign wohnungen in haus
      this.selected.hauser.forEach((h) => {
        if (!h.extended.wohnungen.length) return;
        const bpOfHaus = this.bauprojekte.find((bp) => {
          return bp.id == h.haus_bp;
        });
        h.extended.wohnungen.forEach((w) => {
          let result = {
            bauprojekt: bpOfHaus.name,
            bauprojekt_id: bpOfHaus.id,
            haus: h.name,
            haus_id: h.id,
            wohnung: w.name,
            qm: w.wohnflaeche,
            wohnung_id: w.id,
          };
          const alreadyAssigned = assignedElements.find((el) => {
            return el.wohnung_id == w.id;
          });
          if ("undefined" == typeof alreadyAssigned) assignedElements.push(result);
        });
      });

      //assign single assigned wohnungen
      this.selected.wohnungen.forEach((w) => {
        const hausOfWohnung = this.hauser.find((h) => {
          return h.id == w.haus;
        });
        const bpOfHaus = this.bauprojekte.find((bp) => {
          return bp.id == hausOfWohnung.haus_bp;
        });
        let result = {
          bauprojekt: bpOfHaus.name,
          bauprojekt_id: bpOfHaus.id,
          haus: hausOfWohnung.name,
          haus_id: hausOfWohnung.id,
          wohnung: w.name,
          qm: w.wohnflaeche,
          wohnung_id: w.id,
        };
        const alreadyAssigned = assignedElements.find((el) => {
          return el.wohnung_id == w.id;
        });
        if ("undefined" == typeof alreadyAssigned) assignedElements.push(result);
      });
      this.items.elemente = assignedElements;
      this.totalRows.elemente = assignedElements.length;
    },
    async newLogo() {
      try {
        const logoResponse = await this.$store.dispatch("app/getAsset", this.logo);
        this.logo_source = logoResponse;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden des Logos", this.toast.failure);
      }
    },
    modalSelect(context, selection) {
      this.modal[context] = selection.item;
      console.log("running modalSelect for: " + context);
      console.log(selection);
      if(context == "bauprojekt") this.totalRows.hauser = selection.item.extended.hauser.length;
      if(context == "haus") this.totalRows.wohnungen = selection.item.extended.wohnungen.length;
      
      this.modalStep++;
    },
    goBack() {
      switch (this.modalStep) {
        case 1:
          this.modalStep = 0;
          this.modal.haus = false;
          break;
        case 2:
          this.modalStep = 1;
          this.modal.wohnung = false;
          break;
      }
    },
    updateRelations() {
      this.saveRelation("bauprojekte");
      this.saveRelation("hauser");
      this.saveRelation("wohnungen");
      this.closeAssignmentModal();
    },
    closeAssignmentModal() {
      this.$bvModal.hide("assignDienstleisterElements");
      this.modalStep = 0;
      this.modal.bauprojekt = false;
      this.modal.haus = false;
      this.modal.wohnung = false;
    },
    async saveRelation(items) {
      let targetRelation;
      let targetField;

      switch (items) {
        case "branchen":
          targetRelation = "dienstleister_branchen";
          targetField = "branchen_id";          
          break;
        case "bauprojekte":
          targetRelation = "bauprojekt_dienstleister";
          targetField = "bauprojekt_id";
          break;
        case "hauser":
          targetRelation = "haus_dienstleister";
          targetField = "haus_id";
          break;
        case "wohnungen":
          targetRelation = "wohnung_dienstleister";
          targetField = "wohnung_id";
          break;
      }

      //delete old relation items
      const deletePayload = this.current[items].map((item) => {
        return item.id;
      });
      const newPayload = this.selected[items].map((item) => {
        let res = {
          dienstleister_id: this.id,
        };
        res[targetField] = item.id;
        return res;
      });

      try {
        this.updating[targetRelation] = true;
        if (deletePayload.length) await this.$store.dispatch("app/removeItems", { collection: targetRelation, items: deletePayload });
        if (newPayload.length) await this.$store.dispatch("app/createMultiple", { collection: targetRelation, items: newPayload });
        if (deletePayload.length || newPayload.length) await this.$store.dispatch("app/apiGetDienstleister");
        if (deletePayload.length || newPayload.length) await this.setDlData();
        this.updating.modal = false;
        this.updating[targetRelation] = false;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Speichern der Zuweisung", this.toast.failure);
        this.updating.modal = false;
        this.updating[targetRelation] = false;
      }
    },
    async toggleSelection(context, selection) {
      this.updating.modal = true;
      if ("undefined" == typeof selection.item) {
        selection.item = selection;
      }
      const isSelected = this.selected[context].indexOf(selection.item);
      if (isSelected > -1) this.selected[context].splice(isSelected, 1);
      if (isSelected == -1) this.selected[context].push(selection.item);
      if (context !== "branchen") await this.saveRelation(context);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredElements(filteredItems) {
      this.totalRows.elemente = filteredItems.length;
      this.currentPage = 1;
    },
    isAssigned(context, selection) {
      return this.selected[context].indexOf(selection.item) > -1;
    },
    isAssignedImplicit(context, selection) {
      let result = this.items.elemente.find((elem) => {
        return elem[context] == selection.item.id;
      });

      return result;
    },
    openModal(modal) {
      this.$bvModal.show(modal);
    },
    closeModal(modal) {
      this.$bvModal.hide(modal);
    },
    async setDlData() {
      //set Basic Information
      this.id = this.$route.params.dienstleister_id;
      const current = this.dienstleister.find((dl) => dl.id == this.id);
      this.name = current.name;
      this.telefon = current.telefon;
      this.email = current.email;
      this.logo = current.logo;
      this.ansprechpartner = current.ansprechpartner;

      //set zugewiesene Branchen
      const queryBranchen = {
        collection: "dienstleister_branchen",
        filter: {
          filter: { dienstleister_id: this.id },
        },
      };
      try {
        const currentBranchen = await this.$store.dispatch("app/getRelationItems", queryBranchen);
        this.current.branchen = currentBranchen.data;

        if (currentBranchen.data.length) {
          currentBranchen.data.forEach((branche) => {
            let curr = this.branchen.find((branch) => branch.id == branche.branchen_id);
            if (curr && this.selected.branchen.indexOf(curr) == -1) this.selected.branchen.push(curr);
          });
        }
      } catch (error) {
        this.$toasted.show("Fehler beim Laden der Branchen.", this.toast.failure);
      }

      //set zugewiesene Bauprojekte
      const queryBp = {
        collection: "bauprojekt_dienstleister",
        filter: {
          filter: { dienstleister_id: this.id },
        },
      };

      try {
        const currentBp = await this.$store.dispatch("app/getRelationItems", queryBp);
        this.current.bauprojekte = currentBp.data;
        if (currentBp.data.length) {
          currentBp.data.forEach((bp) => {
            let curr = this.bauprojekte.find((bpr) => bpr.id == bp.bauprojekt_id);
            if (curr && this.selected.bauprojekte.indexOf(curr) == -1) this.selected.bauprojekte.push(curr);
          });
        }
      } catch (error) {
        this.$toasted.show("Fehler beim Laden der Bauprojekt Zuweisungen.", this.toast.failure);
      }

      //set zugewiesene Hauser
      const queryHaus = {
        collection: "haus_dienstleister",
        filter: {
          filter: { dienstleister_id: this.id },
        },
      };

      try {
        const currentHauser = await this.$store.dispatch("app/getRelationItems", queryHaus);
        this.current.hauser = currentHauser.data;
        if (currentHauser.data.length) {
          currentHauser.data.forEach((haus) => {
            let curr = this.hauser.find((h) => haus.haus_id == h.id);
            if (curr && this.selected.hauser.indexOf(curr) == -1) this.selected.hauser.push(curr);
          });
        }
      } catch (error) {
        this.$toasted.show("Fehler beim Laden der Hauszuweisungen.", this.toast.failure);
      }

      //set zugewiesene Wohnungen
      const queryWohnung = {
        collection: "wohnung_dienstleister",
        filter: {
          filter: { dienstleister_id: this.id },
        },
      };

      try {
        const currentWohnung = await this.$store.dispatch("app/getRelationItems", queryWohnung);
        this.current.wohnungen = currentWohnung.data;
        if (currentWohnung.data.length) {
          currentWohnung.data.forEach((woh) => {
            let curr = this.wohnungen.find((wohnung) => woh.wohnung_id == wohnung.id);
            if (curr && this.selected.wohnungen.indexOf(curr) == -1) this.selected.wohnungen.push(curr);
          });
        }
      } catch (error) {
        this.$toasted.show("Fehler beim Laden der Wohnungszuweisungen.", this.toast.failure);
      }
      this.provisionElements();
    },
    setTableData() {
      this.items.branchen = this.branchen;
      this.items.bauprojekte = this.bauprojekte;
      this.items.hauser = this.hauser;
      this.items.wohnungen = this.wohnungen;
      this.totalRows.branchen = this.items.branchen.length;
    },
    async processAsset(response = null, data = null) {
      //handle error / success of upload
      if (!response.xhr.status == 200) {
        this.$toasted.show("Fehler beim Upload", this.toast.error);
        return;
      }
      this.$toasted.show(data.data.filename_download + " Datum.", this.toast.success);
      //check what type of asset was uploaded
      const asset_type = response.previewElement.parentNode.id.split("_")[0];

      try {
        const updateLogo = {
          logo: data.data.id,
        };

        this.logo;
        const updateBildTag = {
          tags: [asset_type],
        };
        await this.$directus.updateItem("directus_files", data.data.id, updateBildTag);
        await this.$directus.updateItem("dienstleister", this.id, updateLogo);
        await this.$store.dispatch("app/apiGetDienstleister");
        await this.newLogo();
      } catch (error) {
        this.$toasted.show("Fehler beim Zuweisen des Dienstleister Logos.", this.toast.success);
      }

      this[asset_type] = data.data.id;
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async validate(field) {
      const fieldName = field.target.name;
      const errorExists = this.validation_errors.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.splice(errorExists, 1);
      this.updating[fieldName] = true;

      const validationPayload = {
        context: "dienstleister",
        field: fieldName,
        value: this[fieldName],
      };

      const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
      if (!validation_result) {
        this.validation_errors.push(fieldName);
        this.updating[fieldName] = false;
        return;
      }

      //mutate the dienstleister and refetch the list
      let mutationPayload = {};
      mutationPayload[fieldName] = this[fieldName];

      try {
        await this.$directus.updateItem("dienstleister", this.id, mutationPayload);
        await this.$store.dispatch("app/apiGetDienstleister");
        this.updating[fieldName] = false;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Aktualisieren von " + fieldName, this.toast.failure);
        this.updating[fieldName] = false;
        this.validation_errors.push(fieldName);
      }
    },
  },
};
</script>

<style>
#select_branchen .form-row,
#select_bauprojekte .form-row,
#select_hauser .form-row,
#select_wohnungen .form-row {
  justify-content: flex-start !important;
}

.search_input .form-control {
  border: 2px solid lightgrey !important;
}

.search_input {
  margin-bottom: 10px;
}
</style>

<style scoped>
.form-group {
  position: relative;
}

.bauprojekt_item,
.haus_item,
.wohnung_item {
  position: relative;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  border: 1px solid lightgrey;
  margin-bottom: 10px;
  padding: 20px;
  width: 100%;
  z-index: 997;
}

.input_container {
  display: flex;
  flex-flow: row;
  z-index: 998;
}

.input_container div button {
  position: relative;
  margin-right: 10px;
  z-index: 999;
}

td[data-label="Auswahl"] {
  text-align: center;
}

.list_headline {
  font-size: 1.2em;
  padding: 10px;
  background: rgb(235, 235, 235);
}

.ico-container {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
}

.logo_thumbnail img {
  width: 255px;
}
</style>

<style scoped>
.checkmark {
  color: green;
}

.failmark {
  color: red;
}

.loader {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  -moz-backdrop-filter: none;
}
.loader,
.checkmark,
.failmark {
  position: absolute !important;
  bottom: 7px;
  right: 10px;
  display: block;
  height: 20px;
  width: 20px;
}

.checkmark.select,
.loader.select {
  right: 30px;
  z-index: 1000;
}
</style>
